/*
 * @Author: Roman
 * @Date: 2022-11-04 11:48:00
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-12-02 18:52:28
 * @FilePath: \qpmn-site\src\app\modules\product\rest\products-rest.service.config.ts
 * @Description: 
 */
import { IRestfulConfigMap } from "@core/data-access/restful";
import { envConfig } from "@env/env-config";

let ProductsRestServiceConfig: IRestfulConfigMap = {
    "productV2RestService": {
        appPath: envConfig.appPath("base"),
        isAuth: true,
        actions: {
            getOne: {
                method: "get",
                path: "api/products/available/:id/v2",
                testPath: "api/products/available/:id/v2",
                paramDefaults: {
                    "id": "@id",
                    "versionedProductAttributeId": "@versionedProductAttributeId"
                }
            },
            creatSku: {
                method: "post",
                path: "api/attributeProperty/:configurableProductId/generateSkuProduct/:propertyModelId",
                testPath: "api/attributeProperty/:configurableProductId/generateSkuProduct/:propertyModelId",
                paramDefaults: {
                    "configurableProductId": "@configurableProductId",
                    "propertyModelId": "@propertyModelId"
                }

            },
            isInternal: {
                method: "get",
                path: "api/products/:pid/internal",
                testPath: "api/products/:pid/internal",
                paramDefaults: { pid: "@pid" }
            },
            pricing: {
                method: "post",
                path: "api/v2/partner/products/:pid/pricing",
                testPath: "api/v2/partner/products/:pid/pricing",
                paramDefaults: { pid: "@pid" }
            },
            pricingGet: {
                method: "get",
                path: "api/v2/products/:pid/pricing/qty/:qty",
                testPath: "api/v2/products/:pid/pricing/qty/:qty",
                paramDefaults: {
                    pid: "@pid",
                    qty: "@qty",
                    currencyCode: "@currencyCode",
                    versionedAttributeId: "@versionedAttributeId"
                }
            },
            getMoq: {
                method: "post",
                path: "api/products/:pid/moq",
                testPath: "",
                paramDefaults: {
                    pid: "@pid"
                }
            },
            // 获取产品描述信息
            getDesc: {
                method: "get",
                path: "api/v2/partner/products/:productId/desc",
                testPath: "api/v2/partner/products/:productId/desc",
                paramDefaults: {
                    productId: "@productId",
                    platformCode: "@platformCode",
                    appTag: "@appTag",
                    appName:"@appName",
                    versionedAttributeId:"@versionedAttributeId",
                    cmsConfigVersion:"@cmsConfigVersion"
                }
            }
        }
    }
}


export { ProductsRestServiceConfig };